import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './core/guards/auth-guard';
import { LoginGuard } from './core/guards/login-guard';
import { PortalUserAuthGuard } from './core/guards/portal-user-auth-guard';
import { HeaderComponent } from './headers/header.component';
import { MobileCenterHeaderComponent } from './headers/mobile-center-header/mobile-center-header.component';
import { TechnicianCenterHeaderComponent } from './headers/technician-center-header/technician-center-header.component';
import { WorkshopCenterHeaderComponent } from './headers/workshop-center-header/workshop-center-header.component';
import { AyLoginComponent } from './login/ay-login.component';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { DispatchProfilePageComponent } from './shared/pages/dispatch-profile-page/dispatch-profile-page.component';
import { NoProfilePageComponent } from './shared/pages/no-profile-page/no-profile-page.component';
import { NotAuthorizedComponent } from './shared/pages/not-authorized/not-authorized.component';
import { AccountingUserAuthGuard } from './core/guards/accounting-user-auth-guard';
import { DealerCenterHeaderComponent } from './headers/dealer-center-header/dealer-center-header.component';
import { DealerUserAuthGuard } from './core/guards/dealer-user-auth-guard';
import { WorkshopUserAuthGuard } from './core/guards/workshop-user-auth-guard';
import { CalculatorUserAuthGuard } from './core/guards/calculator-user-auth-guard';
import { CalculatorCenterHeaderComponent } from './headers/calculator-center-header/calculator-center-header.component';
import { CalculationWebCenterHeaderComponent } from './headers/calculation-web-center-header/calculation-web-center-header.component';
import { PartsSupplierUserAuthGuard } from './core/guards/parts-supplier-user-auth-guard';
import { PartsSupplierCenterHeaderComponent } from './headers/parts-supplier-center-header/parts-supplier-center-header.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard, PortalUserAuthGuard],
    component: HeaderComponent,
    children: [
      {
        path: 'claimsCenter',
        loadChildren: () => import(`src/app/claims-center/claims-center.module`).then(m => m.ClaimsCenterModule),
      },
      {
        path: 'adminCenter',
        loadChildren: () => import(`src/app/admin-center/admin-center.module`).then(m => m.AdminCenterModule),
      },
      {
        path: 'insuranceCompanyCenter',
        loadChildren: () => import(`src/app/insurance-company-center/insurance-company-center.module`).then(m => m.InsuranceCompanyCenterModule),
      },
      {
        path: 'serviceCenter',
        loadChildren: () => import(`src/app/service-center/service-center.module`).then(m => m.ServiceCenterModule),
      },
      {
        canActivate: [AuthGuard, AccountingUserAuthGuard],
        path: 'reportsCenter',
        loadChildren: () => import(`src/app/reports-center/reports-center.module`).then(m => m.ReportsCenterModule),
      },
      {
        canActivate: [AuthGuard, AccountingUserAuthGuard],
        path: 'accountingCenter',
        loadChildren: () => import(`src/app/accounting-center/accounting-center.module`).then(m => m.AccountingCenterModule),
      },
      // {
      //   path: '',
      //   redirectTo: 'dispatch-profile',
      //   pathMatch: 'full'
      // }
    ]
  },
  {
    path: '',
    canActivate: [AuthGuard],
    component: MobileCenterHeaderComponent,
    children: [
      {
        path: 'mobileCenter',
        loadChildren: () => import(`src/app/mobile-center/mobile-center.module`).then(m => m.MobileCenterModule),
      },
    ]
  },
  {
    path: '',
    canActivate: [AuthGuard],
    component: TechnicianCenterHeaderComponent,
    children: [
      {
        path: 'carTechnicianCenter',
        loadChildren: () => import(`src/app/car-technician-center/car-technician-center.module`).then(m => m.CarTechnicianCenterModule),
      },
      {
        path: '',
        redirectTo: 'carTechnicianCenter',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '',
    canActivate: [AuthGuard, WorkshopUserAuthGuard],
    component: WorkshopCenterHeaderComponent,
    children: [
      {
        path: 'workshopCenter',
        loadChildren: () => import(`src/app/workshop-center/workshop-center.module`).then(m => m.WorkshopCenterModule),
      },
      {
        path: '',
        redirectTo: 'workshopCenter',
        pathMatch: 'full'
      }
    ]
  },
   {
    path: '',
    canActivate: [AuthGuard, DealerUserAuthGuard],
    component: DealerCenterHeaderComponent,
    children: [
      {
        path: 'dealerCenter',
        loadChildren: () => import(`src/app/dealer-center/dealer-center.module`).then(m => m.DealerCenterModule),
      },
      {
        path: '',
        redirectTo: 'dealerCenter',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '',
    canActivate: [AuthGuard, PartsSupplierUserAuthGuard],
    component: PartsSupplierCenterHeaderComponent,
    children: [
      {
        path: 'partsSupplierCenter',
        loadChildren: () => import(`src/app/parts-supplier-center/parts-supplier-center.module`).then(m => m.PartsSupplierCenterModule),
      },
      {
        path: '',
        redirectTo: 'partsSupplierCenter',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '',
    canActivate: [AuthGuard, CalculatorUserAuthGuard],
    component: CalculatorCenterHeaderComponent,
    children: [
      {
        path: 'calculationCenter',
        loadChildren: () => import(`src/app/calculation-center/calculation-center.module`).then(m => m.CalculationCenterModule),
      },
      {
        path: '',
        redirectTo: 'calculationCenter',
        pathMatch: 'full'
      }
    ]
  },

   {
    path: '',
    component: CalculationWebCenterHeaderComponent,
    children: [
      {
        path: 'kalkulacja',
        loadChildren: () => import(`src/app/calculation-web-center/calculation-web-center.module`).then(m => m.CalculationWebCenterModule),
      },
      {
        path: '',
        redirectTo: 'kalkulacja',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '',
      children: [
        {
          path: 'documentCenter',
          loadChildren: () => import(`src/app/document-center/document-center.module`).then(m => m.DocumentCenterModule),
        },
        {
          path: 'audanetIntegration',
          loadChildren: () => import(`src/app/feature-module/audanet-integration/audanet-integration.module`).then(m => m.AudanetIntegrationModule),
        },
        {
          path: 'costInvoice',
          loadChildren: () => import(`src/app/feature-module/cost-invoice/cost-invoice.module`).then(m => m.CostInvoiceModule),
        },
        {
        path: 'selfCareCenter',
        loadChildren: () => import(`src/app/self-care-center/self-care-center.module`).then(m => m.SelfCareCenterModule),
      },
      ]
    },
  {
  path: 'open',
    children: [
      {
        path: 'documentsExternal',
        loadChildren: () => import(`src/app/documents-external/documents-external.module`).then(m => m.DocumentsExternalModule),
      }
    ]
  },
  {
    path: 'login',
    component: AyLoginComponent,
    canActivate: [LoginGuard]
  },
  {
    path: 'not-found',
    component: NotFoundComponent
  },
  {
    path: 'no-profile',
    component: NoProfilePageComponent
  },
  {
    path: 'not-authorized',
    component: NotAuthorizedComponent
  },
  {
    path: 'dispatch-profile',
    component: DispatchProfilePageComponent
  },
  {
    path: '**',
    redirectTo: 'dispatch-profile',
    pathMatch: 'full'
  },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', paramsInheritanceStrategy: 'always' })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
